import { put, select, takeLatest } from 'redux-saga/effects'
import { QuickActionsConstants } from '../store/quickActions.constants'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { IQuickActionButton, ISelectedQuickActionButton } from '../store/quickActions.types'
import { setFilteredQuickActionButtons, setParentQuickActionLabel } from '../store/quickActions.actions'
import { IOption, IOptions } from '../../../common/common.types'
import { getAddMedicationAdministeredOptionsSelector, getImmobilizationOptionsSelector } from '../../options/selectors'

export function* filteredQuickActionButtons() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { selectedQuickActionId, quickActionButtons, quickActions, savedQuickActionButtons } = quickActionsObject
  const parentQuickAction = quickActions.filter((action: IOption) => action.id === selectedQuickActionId)
  yield put(setParentQuickActionLabel(parentQuickAction[0].name))

  const addMedicationAdministeredOptionsState = yield select(getAddMedicationAdministeredOptionsSelector)
  const { doseUnitOptions } = addMedicationAdministeredOptionsState

  const immobilizationOptions = yield select(getImmobilizationOptionsSelector)
  const { optionOptions } = immobilizationOptions

  const filteredButtons = quickActionButtons.filter(
    (button: IQuickActionButton) => button.quickActionPage === selectedQuickActionId
  )

  const getProcInfo = (procInfo: string) => {
    const dataObject = procInfo.split('|')

    const doseUnit: IOptions = doseUnitOptions.filter(
      (unit: IOption) => dataObject[3] && unit.id === Number(dataObject[3])
    )

    const title2Data = `${dataObject[2] || ''} ${(doseUnit && doseUnit[0] && doseUnit[0].name?.toLowerCase()) || ''}`
    return title2Data
  }

  const getOption = (button: IQuickActionButton) => {
    if (button.procName?.toLowerCase() !== 'immobilization') {
      return
    }
    const dataObject = button.procInfo.split('|')
    return optionOptions.find((unit: IOption) => unit.id && dataObject.includes(String(unit.id)))
  }

  const getRouteId = (procInfo: string) => {
    const dataObject = procInfo.split('|')
    return dataObject[4] || ''
  }

  const getButtonSubTitle = (button: IQuickActionButton) => {
    if (button.procName && button.procName === 'Medication' && button.procInfo && getProcInfo(button.procInfo)) {
      const dose = getProcInfo(button.procInfo)
      if (button.title2 && dose && dose.trim()) {
        return button.title2 + '\n\n' + dose
      } else {
        return dose
      }
    }
    return button.title2
  }

  const newButtons = filteredButtons.map((button: IQuickActionButton) => {
    return {
      key: button.id.toString(),
      type: 'quickAction',
      buttonCol: button.buttonCol,
      buttonRow: button.buttonRow,
      procName: button.procName,
      comments: button.comments,
      id: button.id,
      maxTimes: button.maxTimes,
      props: {
        procId: button.procedureAction,
        procedureAction: button.procedureAction,
        label: button.title1,
        title2: getButtonSubTitle(button),
        option: getOption(button),
        doseObj: button.procInfo ? getProcInfo(button.procInfo) : '',
        routeId: button.procInfo ? getRouteId(button.procInfo) : '',
        id: button.id.toString(),
        buttonId: button.id,
        action: QuickActionsConstants.SET_SELECTED_QUICK_ACTION_BUTTON_ID,
        timer: true,
        startTime: { hours: 0, minutes: 0, seconds: 0 },
        savedTime: button.savedTime,
        prevTime: undefined,
        timerDirection: 'up',
        showCount: true,
        count: button.count | 0,
        disabled: false,
        showFlash: button.timeToWarn != 0,
        flashColor: 'danger',
        showToastMessage: true,
        flashTimes: [
          {
            hours: '',
            minutes: '0' + button.timeToWarn?.toString(),
            seconds: '00',
          },
        ],
        parentQuickAction: parentQuickAction[0].name,
      },
    }
  })

  const savedNewButtons = newButtons.map((qa: ISelectedQuickActionButton) => {
    if (savedQuickActionButtons.length) {
      const index = savedQuickActionButtons.findIndex((i: ISelectedQuickActionButton) => i.id === qa.id)
      if (index !== -1) {
        return (qa = savedQuickActionButtons[index])
      } else {
        return qa
      }
    } else {
      return qa
    }
  })

  yield put(setFilteredQuickActionButtons(savedNewButtons))
}
export function* setFilteredQuickActionButtonsSaga() {
  yield takeLatest([QuickActionsConstants.FILTER_QUICK_ACTION_BUTTONS], filteredQuickActionButtons)
}
